import NoPortfolioImage from 'src/shared/features/users/assets/empty/house.png'

import EmptyView from './empty-view'

const NoPortfolio = ({ firstName }: { firstName: string }) => {
  return (
    <EmptyView
      description={`${firstName} hasn't added any work to share here.`}
      image={<img src={NoPortfolioImage} className="translate-y-7 md:translate-y-5" />}
      title={`Nothing in ${firstName}'s portfolio, yet.`}
    />
  )
}

export default NoPortfolio
